import {
  createTenderOpeningVendor,
  updateTenderOpeningVendor,
} from "@api/procurements/procurementDetails/tenderOpeningVendor";
import { ErrorModal, MultiFileRow, SuccessModal } from "@components";
import { useTenderOpeningVendor } from "@hooks/procurements/procurement/useTenderOpeningVendor";
import { Button, Modal } from "@pentabd/ui";
import {
  convertDocumentData,
  convertMultipleDocumentData,
  revertMultipleDocumentData,
} from "@utils/documentDataConvert";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

type VendorDocModalProps = {
  openModal: boolean;
  closeFileUploadModal: () => void;
  vendorOpeningId: number;
  vendorInfoId: number | string | null;
};

export default function VendorDocModal({
  openModal,
  closeFileUploadModal,
  vendorOpeningId,
  vendorInfoId,
}: VendorDocModalProps) {
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);

  const { t } = useTranslation();
  const { getSingleData } = useTenderOpeningVendor(vendorInfoId as any);

  const { control, register, setValue, handleSubmit } = useForm({
    values: revertMultipleDocumentData(getSingleData, ["documents"]),
  });

  const onSubmit = async (data: any) => {
    try {
      const convertedData = convertMultipleDocumentData(data, ["documents"]);
      let resData;

      if (getSingleData?.documents?.length > 0) {
        resData = await updateTenderOpeningVendor(
          convertedData,
          vendorInfoId as any,
          vendorOpeningId,
        );
      } else {
        resData = await createTenderOpeningVendor(
          convertedData,
          vendorInfoId as any,
        );
      }
      closeFileUploadModal();

      if (resData?.status === "SUCCESS") {
        setIsSuccessModalOpen(true);
      }
    } catch (error) {
      setIsErrorModalOpen(true);
    }
  };

  const createSuccessAction = () => {
    setIsSuccessModalOpen(false);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  return (
    <div>
      {/* modals  */}
      {isSuccessModalOpen && (
        <SuccessModal
          isModalOpen={isSuccessModalOpen}
          action={createSuccessAction}
        />
      )}
      {isErrorModalOpen && (
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
      )}
      {/* modals end */}

      <Modal
        isOpen={openModal}
        portal
        overlay={openModal}
        closeAble
        onClose={closeFileUploadModal}
      >
        <form className="container" onSubmit={handleSubmit(onSubmit)}>
          <div className="p-10 w-100">
            <MultiFileRow
              name="documents"
              register={register}
              setValue={setValue}
              control={control}
              fileDetails={["documentName", "date", "remarks", "memorialNo"]}
              isVertical={true}
            />
            <div className="text-end col-12 py-10">
              <Button
                fill="outline"
                type="light"
                size="sm"
                htmlType="submit"
              >
                {t("PROCUREMENT_CREATE.SPEC_PREPARATION.FORM.BUTTONS.SAVE")}
              </Button>
            </div>
          </div>
        </form>
      </Modal>
    </div>
  );
}
